
<table class="table">
  <ng-container *ngIf="isColaborator || subsidiary; else storeView">
  </ng-container>
  <ng-template #storeView>
    <thead>
      <th>Estado</th>
      <th>ID</th>
      <th>Nombre</th>
      <th>Acciones</th>
    </thead>
    <tbody>
      <tr *ngFor="let item of brands" >
        <td>
          <div *ngIf="item.status === 'ACTIVE'" class="active-container">
            <p>ACTIVA</p>
          </div>
          <div *ngIf="item.status === 'INACTIVE'" class="inactive-container">
            <p>INACTIVA</p>
          </div>
        </td>
        <td>{{item.id}}</td>
        <td>{{item.name}}</td>
        <td  class="actions-cell">
          <button class="icon-button edit" (click)="editar(item)">
              <i class="fa fa-pencil-square-o"></i>
          </button>
          <button class="icon-button delete"
                (click)="onDeleteClick(item)">
            <i class="fa fa-trash-o"></i>
        </button>
      </td>
      </tr>
    </tbody>

  </ng-template>
</table>